import {FC, useCallback, useEffect, useMemo, useRef, useState} from "react";
import {SHARED_ICONS_LIST} from "./SharedIcons";
import {ShareIconItem} from "./ShareIconItem";
import {FlexBox, useIsMobile} from "@brg/ui";
import styled from "styled-components";
import {ArrowLeftIcon, ArrowRightIcon} from "./ArrowIcons";
import {LayoutConst} from "../../../../core";

const SharedIconListWrapper = styled(FlexBox)`
  overflow: hidden;
  position: relative;
  align-items: center;
  width: 100%;
  padding: 0 10px;
  flex-shrink: 0;

  @media(max-width: ${LayoutConst.screen.s -1}px) {
    padding: 0;
  }
`

const SharedIconHorizontalScroller = styled(FlexBox)`
  overflow: hidden;
  position: relative;
  align-items: center;
  width: 100%;
  column-gap: 8px;
  padding: 0 0 0 0;
  justify-content: space-between;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  &::-webkit-scrollbar-thumb {
    background-color: transparent;    /* color of the scroll thumb */
    border: none
  }&::-webkit-scrollbar-track {
    background-color: transparent;    /* color of the scroll thumb */
  }
  
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    overflow-x: scroll;
    padding: 0 10px 5px 10px;
    // column-gap: 3.5vw;
    column-gap: 8px;
  }
`

const AbsoluteWrapper = styled(FlexBox)`
  position: absolute;
  cursor: pointer;
  width: 50px;
  height: 100%;
  align-items: center;
  z-index: 1;

  &:hover {
    svg {
      path {
        fill: #545453;
      }
    }
  }
`

const LeftArrowWrapper = styled(AbsoluteWrapper)`
  background: linear-gradient(-90deg, rgba(254, 254, 254, 0) 0%, #FEFEFE 71.35%);
  left: 0;
`

const RightArrowWrapper = styled(AbsoluteWrapper)`
  background: linear-gradient(90deg, rgba(254, 254, 254, 0) 0%, #FEFEFE 71.35%);
  justify-content: flex-end;
  right: 0;
`

export interface SharedIconListProps {
    title: string;
    imgUrl: string | null;
    link: string;
    isMobile?: boolean;
}

export const SharedIconList: FC<SharedIconListProps> = (props) => {

    const isMobile = useIsMobile();
    const listRef = useRef<HTMLDivElement>(null);
    const [scrollLeft, setScrollLeft] = useState(0);

    const onClickArrow = useCallback((action: 'left' | 'right') => {
        if (!listRef?.current) return;
        const fullWidth = listRef?.current?.scrollWidth - listRef?.current?.clientWidth;
        let newScrollLeft = action === 'left' ? listRef?.current.scrollLeft - 150 : listRef?.current.scrollLeft + 150;
        if (newScrollLeft < 0) newScrollLeft = 0;
        if (newScrollLeft > fullWidth) newScrollLeft = fullWidth;
        setScrollLeft(newScrollLeft)
        listRef?.current.scrollTo({
            left: newScrollLeft,
            behavior: "smooth"
        })
    }, [listRef, listRef?.current?.scrollLeft])

    const isFullLeft = useMemo(() => listRef?.current ? scrollLeft === 0 : true, [listRef, scrollLeft])
    const isFullRight = useMemo(() =>
            listRef?.current ? scrollLeft === (listRef?.current?.scrollWidth - listRef?.current?.clientWidth) : false,
        [listRef, scrollLeft, listRef?.current?.scrollWidth])

    return <SharedIconListWrapper>
{/*        {!isMobile && <>{!isFullLeft && <LeftArrowWrapper onClick={() => onClickArrow('left')}>
            <ArrowLeftIcon/>
        </LeftArrowWrapper>}
        {!isFullRight && <RightArrowWrapper onClick={() => onClickArrow('right')}>
            <ArrowRightIcon/>
        </RightArrowWrapper>}</>}*/}
        <SharedIconHorizontalScroller ref={listRef}>
            {Object.values(SHARED_ICONS_LIST)
                .filter(icon => icon.languages.includes("ru"))
                .filter(icon => !(!isMobile && icon?.mobileOnly))
                .map(icon => {return <ShareIconItem title={icon.title} icon={icon.icon} link={icon.getLink({...props, isMobile})}/>})
            }
        </SharedIconHorizontalScroller>
    </SharedIconListWrapper>
}import {FC, useCallback, useEffect, useMemo, useRef, useState} from "react";
import {SHARED_ICONS_LIST} from "./SharedIcons";
import {ShareIconItem} from "./ShareIconItem";
import {FlexBox, useIsMobile} from "@brg/ui";
import styled from "styled-components";
import {ArrowLeftIcon, ArrowRightIcon} from "./ArrowIcons";
import {LayoutConst} from "../../../../core";

const SharedIconListWrapper = styled(FlexBox)`
  overflow: hidden;
  position: relative;
  align-items: center;
  width: 100%;
  padding: 0 10px;
  flex-shrink: 0;

  @media(max-width: ${LayoutConst.screen.s -1}px) {
    padding: 0;
  }
`

const SharedIconHorizontalScroller = styled(FlexBox)`
  overflow: hidden;
  position: relative;
  align-items: center;
  width: 100%;
  column-gap: 8px;
  padding: 0 0 0 0;
  justify-content: space-between;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  &::-webkit-scrollbar-thumb {
    background-color: transparent;    /* color of the scroll thumb */
    border: none
  }&::-webkit-scrollbar-track {
    background-color: transparent;    /* color of the scroll thumb */
  }
  
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    overflow-x: scroll;
    padding: 0 10px 5px 10px;
    // column-gap: 3.5vw;
    column-gap: 8px;
  }
`

const AbsoluteWrapper = styled(FlexBox)`
  position: absolute;
  cursor: pointer;
  width: 50px;
  height: 100%;
  align-items: center;
  z-index: 1;

  &:hover {
    svg {
      path {
        fill: #545453;
      }
    }
  }
`

const LeftArrowWrapper = styled(AbsoluteWrapper)`
  background: linear-gradient(-90deg, rgba(254, 254, 254, 0) 0%, #FEFEFE 71.35%);
  left: 0;
`

const RightArrowWrapper = styled(AbsoluteWrapper)`
  background: linear-gradient(90deg, rgba(254, 254, 254, 0) 0%, #FEFEFE 71.35%);
  justify-content: flex-end;
  right: 0;
`

export interface SharedIconListProps {
    title: string;
    imgUrl: string | null;
    link: string;
    isMobile?: boolean;
}

export const SharedIconList: FC<SharedIconListProps> = (props) => {

    const isMobile = useIsMobile();
    const listRef = useRef<HTMLDivElement>(null);
    const [scrollLeft, setScrollLeft] = useState(0);

    const onClickArrow = useCallback((action: 'left' | 'right') => {
        if (!listRef?.current) return;
        const fullWidth = listRef?.current?.scrollWidth - listRef?.current?.clientWidth;
        let newScrollLeft = action === 'left' ? listRef?.current.scrollLeft - 150 : listRef?.current.scrollLeft + 150;
        if (newScrollLeft < 0) newScrollLeft = 0;
        if (newScrollLeft > fullWidth) newScrollLeft = fullWidth;
        setScrollLeft(newScrollLeft)
        listRef?.current.scrollTo({
            left: newScrollLeft,
            behavior: "smooth"
        })
    }, [listRef, listRef?.current?.scrollLeft])

    const isFullLeft = useMemo(() => listRef?.current ? scrollLeft === 0 : true, [listRef, scrollLeft])
    const isFullRight = useMemo(() =>
            listRef?.current ? scrollLeft === (listRef?.current?.scrollWidth - listRef?.current?.clientWidth) : false,
        [listRef, scrollLeft, listRef?.current?.scrollWidth])

    return <SharedIconListWrapper>
{/*        {!isMobile && <>{!isFullLeft && <LeftArrowWrapper onClick={() => onClickArrow('left')}>
            <ArrowLeftIcon/>
        </LeftArrowWrapper>}
        {!isFullRight && <RightArrowWrapper onClick={() => onClickArrow('right')}>
            <ArrowRightIcon/>
        </RightArrowWrapper>}</>}*/}
        <SharedIconHorizontalScroller ref={listRef}>
            {Object.values(SHARED_ICONS_LIST)
                .filter(icon => icon.languages.includes("ru"))
                .filter(icon => !(!isMobile && icon?.mobileOnly))
                .map(icon => {return <ShareIconItem title={icon.title} icon={icon.icon} link={icon.getLink({...props, isMobile})}/>})
            }
        </SharedIconHorizontalScroller>
    </SharedIconListWrapper>
}